import {type} from '../utilities/type';
import {Action} from '@ngrx/store';


export const isSfInvoicedActionTypes = {
  IS_SF_INVOICED: type('[Is Sf Invoiced] Start'),
  IS_SF_INVOICED_SUCCESS: type('[Is Sf Invoiced]  Success'),
  IS_SF_INVOICED_FAIL: type('[Is Sf Invoiced]  Fail'),
};

export class IsSfInvoicedAction implements Action {
  readonly type = isSfInvoicedActionTypes.IS_SF_INVOICED;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any ) {}
}

export class IsSfInvoicedSuccessAction implements Action {
  readonly type = isSfInvoicedActionTypes.IS_SF_INVOICED_SUCCESS;
  constructor(public payload?: boolean) {}
}

export class IsSfInvoicedFailAction implements Action {
  readonly type = isSfInvoicedActionTypes.IS_SF_INVOICED_FAIL;
  constructor(public payload?: string) {}
}


